<label class="radio-btn-container" [ngClass]="{ 'no-interaction': isDisabled }">
  <input type="checkbox" [checked]="value" [ngClass]="{ 'no-interaction': isDisabled }" />
  <span class="checkmark"></span>
  <span class="label-text" *ngIf="labelText"> {{ labelText }}</span>
</label>
